import { Icon } from '@iconify/react';
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import DeleteIcon from '@mui/icons-material/Delete';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import { getAdminRoleFromHierarchy } from '../../../utils/Utilities';
import { APP_CONSTANTS } from '../../../URLConstants';

// ----------------------------------------------------------------------

UserMoreMenu.propTypes = {
  userData: PropTypes.object,
  handleClicks: PropTypes.func,
  sx: PropTypes.object
};

export default function UserMoreMenu({ userData, handleClicks, sx, userRole }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const role =
    userData?.role === APP_CONSTANTS?.USER_ROLE_ADMIN
      ? getAdminRoleFromHierarchy(userData?.taxonomy?.path)
      : userData?.role;

  return (
    <>
      <IconButton
        data-testid="user_more_menu_click"
        sx={{ ...sx }}
        ref={ref}
        onClick={() => setIsOpen(true)}
      >
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { minWidth: 220, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => {
            setIsOpen(false);
            handleClicks(userData?.activated ? 'deactivate' : 'activate');
          }}
          sx={{ color: 'text.secondary' }}
          data-testid={userData?.activated ? 'deactivate_user' : 'activate_user'}
        >
          <ListItemIcon>
            {userData?.activated ? (
              <RemoveCircleOutlineOutlinedIcon color="error" />
            ) : (
              <AddCircleOutlineOutlinedIcon color="success" />
            )}
          </ListItemIcon>
          <ListItemText
            primary={userData?.activated ? 'De-activate' : 'Activate'}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </MenuItem>
        {userRole !== 'Admin' && role !== 'Admin' && userRole === role ? null : (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              handleClicks('edit-user');
            }}
            sx={{ color: 'text.secondary' }}
            data-testid="edit_user"
          >
            <ListItemIcon>
              <PersonAddAlt1OutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Edit User" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        {userRole === 'HOAdmin'
          ? userRole !== role && (
              <MenuItem
                onClick={() => {
                  setIsOpen(false);
                  handleClicks('delete-user');
                }}
                sx={{ color: 'text.secondary' }}
                data-testid="delete_user"
              >
                <ListItemIcon>
                  <DeleteIcon />
                </ListItemIcon>
                <ListItemText primary="Delete User" primaryTypographyProps={{ variant: 'body2' }} />
              </MenuItem>
            )
          : null}
      </Menu>
    </>
  );
}
